import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _get from 'lodash/get';
import _isArray from 'lodash/isArray';
import _isEmpty from 'lodash/isEmpty';
import _isNumber from 'lodash/isNumber';
import { ANIMATION_CONTAINER_ID, FADE_IN_CLASS, FADE_OUT_CLASS, ANIMATION_IN_DURATION_MS, ANIMATION_OUT_DURATION_MS, SPINNING_CLASS, FADE_PAGE_TRANSITION, DEFAULT_ENABLED } from './PageTransition.constants';
import { isServerSideRendering } from '../../../../utils/gatsby';
export function getSettings(_ref) {
  var transition = _ref.transition,
    durationIn = _ref.durationIn,
    durationOut = _ref.durationOut,
    animationsContext = _ref.animationsContext;
  var pageTransition = _get(animationsContext, 'pageTransition', {});
  var enabled;
  if (_isEmpty(animationsContext)) {
    enabled = DEFAULT_ENABLED;
  } else {
    enabled = !!_get(animationsContext, 'enabled') && !!_get(pageTransition, 'enabled');
  }
  return {
    enabled: enabled,
    transition: !_isEmpty(transition) ? transition : _get(pageTransition, 'transition'),
    durationIn: _isNumber(durationIn) ? durationIn : _get(pageTransition, 'durationIn'),
    durationOut: _isNumber(durationOut) ? durationOut : _get(pageTransition, 'durationOut')
  };
}
function sleep(_x) {
  return _sleep.apply(this, arguments);
}
function _sleep() {
  _sleep = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(duration) {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          return _context3.abrupt("return", new Promise(function (resolve) {
            return setTimeout(resolve, duration);
          }));
        case 1:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _sleep.apply(this, arguments);
}
function areAnimationsSupported() {
  if (isServerSideRendering()) {
    return false;
  }
  return !!window.AnimationEvent;
}
export function isPageTransitionEnabled() {
  if (isServerSideRendering()) {
    return false;
  }
  var container = document.getElementById(ANIMATION_CONTAINER_ID);
  return !!container;
}
function getParentContainer(parentSelector) {
  if (parentSelector) {
    var query = document.querySelector(parentSelector);
    var parent = _isArray(query) ? query[0] : query;
    if (parent) {
      parent.style.position = 'relative';
      var _firstChild = parent.firstChild;
      return [parent, _firstChild];
    }
  }
  var _document = document,
    body = _document.body;
  var firstChild = body.firstChild;
  return [body, firstChild];
}
function getOrCreateTransitionContainer() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    duration = _ref2.duration,
    parentSelector = _ref2.parentSelector;
  if (!areAnimationsSupported() || !duration) {
    return null;
  }
  var container = document.getElementById(ANIMATION_CONTAINER_ID);
  if (!container) {
    var _document2 = document,
      body = _document2.body;
    var _getParentContainer = getParentContainer(parentSelector),
      _getParentContainer2 = _slicedToArray(_getParentContainer, 2),
      parent = _getParentContainer2[0],
      firstChild = _getParentContainer2[1];
    var isBody = parent === body;
    var transitionContainer = document.createElement('div');
    transitionContainer.id = ANIMATION_CONTAINER_ID;
    transitionContainer.style.position = isBody ? 'fixed' : 'absolute';
    var spinner = document.createElement('div');
    spinner.classList.add('spinner');
    transitionContainer.appendChild(spinner);
    container = parent.insertBefore(transitionContainer, firstChild);
  }
  container.style.animationDuration = "".concat(duration, "ms");
  return container;
}
function fadeIn(_x2, _x3) {
  return _fadeIn.apply(this, arguments);
}
function _fadeIn() {
  _fadeIn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(container, duration) {
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          window.scrollTo({
            top: 0,
            behavior: 'instant'
          });
          container.classList.add(FADE_IN_CLASS);
          container.classList.remove(FADE_OUT_CLASS);
          container.classList.remove(SPINNING_CLASS);
          _context4.next = 6;
          return sleep(duration);
        case 6:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _fadeIn.apply(this, arguments);
}
function fadeOut(_x4) {
  return _fadeOut.apply(this, arguments);
}
function _fadeOut() {
  _fadeOut = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(container) {
    var _ref4,
      duration,
      _args5 = arguments;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _ref4 = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : {}, duration = _ref4.duration;
          container.classList.add(FADE_OUT_CLASS);
          container.classList.remove(FADE_IN_CLASS);
          _context5.next = 5;
          return sleep(duration);
        case 5:
          container.classList.add(SPINNING_CLASS);
        case 6:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return _fadeOut.apply(this, arguments);
}
function pageInTransition() {
  return _pageInTransition.apply(this, arguments);
}
function _pageInTransition() {
  _pageInTransition = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
    var _ref5,
      transition,
      duration,
      container,
      transitions,
      transitionFunction,
      _args6 = arguments;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          _ref5 = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : {}, transition = _ref5.transition, duration = _ref5.duration;
          container = getOrCreateTransitionContainer({
            duration: duration
          });
          if (container) {
            _context6.next = 4;
            break;
          }
          return _context6.abrupt("return");
        case 4:
          transitions = _defineProperty({}, FADE_PAGE_TRANSITION, fadeIn);
          transitionFunction = _get(transitions, transition, function () {});
          _context6.next = 8;
          return transitionFunction(container, {
            duration: duration
          });
        case 8:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return _pageInTransition.apply(this, arguments);
}
function pageOutTransition() {
  return _pageOutTransition.apply(this, arguments);
}
function _pageOutTransition() {
  _pageOutTransition = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
    var _ref6,
      transition,
      duration,
      parentSelector,
      container,
      transitions,
      transitionFunction,
      _args7 = arguments;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          _ref6 = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : {}, transition = _ref6.transition, duration = _ref6.duration, parentSelector = _ref6.parentSelector;
          container = getOrCreateTransitionContainer({
            duration: duration,
            parentSelector: parentSelector
          });
          if (container) {
            _context7.next = 4;
            break;
          }
          return _context7.abrupt("return");
        case 4:
          transitions = _defineProperty({}, FADE_PAGE_TRANSITION, fadeOut);
          transitionFunction = _get(transitions, transition, function () {});
          _context7.next = 8;
          return transitionFunction(container, {
            duration: duration
          });
        case 8:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return _pageOutTransition.apply(this, arguments);
}
var pageTransitionControllerInstance = null;
export var PageTransitionController = /*#__PURE__*/function () {
  function PageTransitionController() {
    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref3$enabled = _ref3.enabled,
      enabled = _ref3$enabled === void 0 ? DEFAULT_ENABLED : _ref3$enabled,
      _ref3$transition = _ref3.transition,
      transition = _ref3$transition === void 0 ? FADE_PAGE_TRANSITION : _ref3$transition,
      _ref3$durationIn = _ref3.durationIn,
      durationIn = _ref3$durationIn === void 0 ? ANIMATION_IN_DURATION_MS : _ref3$durationIn,
      _ref3$durationOut = _ref3.durationOut,
      durationOut = _ref3$durationOut === void 0 ? ANIMATION_OUT_DURATION_MS : _ref3$durationOut,
      _ref3$parentSelector = _ref3.parentSelector,
      parentSelector = _ref3$parentSelector === void 0 ? null : _ref3$parentSelector,
      _ref3$onPreAnimation = _ref3.onPreAnimation,
      onPreAnimation = _ref3$onPreAnimation === void 0 ? function () {} : _ref3$onPreAnimation,
      _ref3$onPostAnimation = _ref3.onPostAnimation,
      onPostAnimation = _ref3$onPostAnimation === void 0 ? function () {} : _ref3$onPostAnimation;
    _classCallCheck(this, PageTransitionController);
    if (!pageTransitionControllerInstance) {
      this.enabled = enabled;
      this.transition = transition;
      this.durationIn = durationIn;
      this.durationOut = durationOut;
      this.parentSelector = parentSelector;
      this.onPreAnimation = onPreAnimation;
      this.onPostAnimation = onPostAnimation;
      if (this.enabled) {
        getOrCreateTransitionContainer({
          duration: this.durationIn,
          parentSelector: this.parentSelector
        });
      }

      // singleton
      pageTransitionControllerInstance = this;
    }
    return pageTransitionControllerInstance;
  }
  _createClass(PageTransitionController, [{
    key: "pageIn",
    value: function () {
      var _pageIn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (this.enabled) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              _context.next = 4;
              return this.onPreAnimation();
            case 4:
              _context.next = 6;
              return pageInTransition({
                transition: this.transition,
                duration: this.durationIn,
                parentSelector: this.parentSelector
              });
            case 6:
              _context.next = 8;
              return this.onPostAnimation();
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function pageIn() {
        return _pageIn.apply(this, arguments);
      }
      return pageIn;
    }()
  }, {
    key: "pageOut",
    value: function () {
      var _pageOut = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (this.enabled) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return");
            case 2:
              _context2.next = 4;
              return this.onPreAnimation();
            case 4:
              _context2.next = 6;
              return pageOutTransition({
                transition: this.transition,
                duration: this.durationOut,
                parentSelector: this.parentSelector
              });
            case 6:
              _context2.next = 8;
              return this.onPostAnimation();
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function pageOut() {
        return _pageOut.apply(this, arguments);
      }
      return pageOut;
    }()
  }]);
  return PageTransitionController;
}();